import React, { useEffect, useState } from "react";
import "./NewPassword.css";
import {validatefogpass} from '../../Utils/validate';
import { Form } from 'react-bootstrap';
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import { gettoastsuccess,gettoastwarning } from '../../Utils/Common';

const NewPassword = () => {
  const [loading,setLoading] = useState(false);
  const [error,setError] = useState();
  const [errors,setErrors] = useState({});

  const [inputs,setInputs] = useState({newPassword:'',confirmPassword:''});

  // States for toggling password visibility
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    document.title = `NewPassword | bluefaucet`;
    document.getElementById('bodywrap').className='login';
    /*if (localStorage.getItem('otp') !== null) {
    
    }else
    {   
      window.location.href = "/otp";
    }*/

  },[]); 

/* Start Value set */
const handleInputChange = (event) => {
  event.persist();
  setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
}
/* End Value set */

//Start Password Update
const handleSubmit = (event) => {
  event.preventDefault();
  const validationErrors = validatefogpass(inputs);
  const noErrors = Object.keys(validationErrors).length === 0;
  setError('');
  setErrors({});
  setErrors(validationErrors);
  if(noErrors){
      setLoading(true);
    let newPassword=inputs.newPassword;
    let confirmPassword=inputs.confirmPassword;
    let otp=localStorage.getItem('otp');
    const otp1 = otp.replace(/,/g, '');
    let formData = new FormData(); 
      formData.append('newPassword', newPassword);
      formData.append('confirmPassword', confirmPassword);
      formData.append('code', otp1);
      API.post('backoffice_reset_password_update', formData)
        .then(response => {
          setLoading(false); 
        if(response.data.status === 0){
          setLoading(false); 
          gettoastwarning(response.data.message,'');
        }else{
          localStorage.removeItem("otp");
          localStorage.removeItem("email");
           //navigate('/login');
           gettoastsuccess(response.data.message,'/');
        }                  
      }).catch(error => {
         setLoading(false);
          gettoastwarning("Something went wrong. Please try again later.",'');
      });  
  }
}

  
  return (
    <>
      <div className="container d-flex align-items-center justify-content-center mains">
        <div className="row w-100 flex-column flex-md-row justify-content-center">
          <div className="col-md-12 d-flex flex-column flex-md-row p-0 vach">
            {/* Right Section - Brand Info (Shown First on Mobile) */}
            <div className="col-md-5 right-section d-flex flex-column justify-content-center align-items-center order-md-2">
              <div className="right-logo">
                <img
                  src="/assests/images/bluefaucet-logo.png"
                  alt="BlueFaucet Logo"
                  className="img-fluid"
                />
              </div>
              <p>
                Welcome to BlueFaucet
                <br />
                Where we take care of your business.
              </p>
              <div className="position-relative hello w-100">
                <div className="de-1">
                  <img
                    src="/assests/images/round.png"
                    alt="Decor 1"
                    className="img-fluid"
                  />
                </div>
                <div className="de-2">
                  <img
                    src="/assests/images/trikon.png"
                    alt="Decor 2"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>

            {/* Left Section - Sign In Form */}
            <div className="col-md-7 left-section forgu d-flex flex-column justify-content-center">
              <h2>New Password</h2>
              {error && (
              <div className="alert alert-danger">
                {error}
              </div>)}
              <form method="post" onSubmit={handleSubmit} enctype="multipart/form-data">
                <Form.Group className="mb-4">
                    <div className="input-group ggh mb-0">
                      <span className="input-group-text">
                        <img
                          src="/assests/images/password.png"
                          alt="Lock Icon"
                          className="img-fluid"
                        />
                      </span>
                      <input
                        type={showNewPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="New Password"
                        name="newPassword"
                        onChange={handleInputChange}
                      />
                      
                      <div
                        className="input-group-text"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowNewPassword(!showNewPassword)}
                      >
                        <img
                          src={
                            showNewPassword
                              ? "/assests/images/frame-4.png" 
                              : "/assests/images/frame-3.png" 
                          }
                          alt="Toggle Password"
                          className="img-fluid"
                        />
                      </div>

                    </div>
                    {errors.newPassword && (<p className="text-danger text-start mb-0">{errors.newPassword}</p>)}
                    </Form.Group>

                <div className="input-group ggh">
                  <span className="input-group-text">
                    <img
                      src="/assests/images/password.png"
                      alt="Lock Icon"
                      className="img-fluid"
                    />
                  </span>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="Confirm Password"
                    name="confirmPassword"
                    onChange={handleInputChange}
                  />
                  <div
                    className="input-group-text"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    <img
                      src={
                        showConfirmPassword
                          ? "/assests/images/frame-4.png"
                          : "/assests/images/frame-3.png"
                      }
                      alt="Toggle Password"
                      className="img-fluid"
                    />
                  </div>
                  {errors.confirmPassword && (<p className="text-danger text-start mb-0">{errors.confirmPassword}</p>)}
                </div>
                <button type="submit" className="btn w-100">
                  SUBMIT
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {loading && (
         <div className="loadingClass">
          <img src={loader} alt="loader"/>
        </div>
         )}
    </>
  );
};

export default NewPassword;
